import "./PdfPreview.scss"
import { useState } from "react";
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import 'react-pdf/dist/esm/Page/TextLayer.css'
import { useResizeDetector } from 'react-resize-detector'

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@4.4.168/build/pdf.worker.min.mjs`;

const PdfPreview = ({ pdfUrl, fileType = "pdf" }) => {
    const [numPages, setNumPages] = useState(null);
    const { width, ref } = useResizeDetector();
    const [loading, setLoading] = useState(true);

    const defaultWidth = 800;
    const scaleFactor = width ? width / defaultWidth : 1;
    const scale = Math.min(1, scaleFactor);

    // Check if the file is an image
    const images = ["jpeg", "jpg", "png", "gif", "webp"];

    function onDocumentLoadSuccess({ numPages }) {
        setLoading(false);
        setNumPages(numPages);
    }

    const onLoadError = (error) => {
        console.error(error);
        setLoading(false);
    };

    return (
        <div className="pdf-preview" ref={ref}>
            {images.includes(fileType) ? (
                <img
                    src={pdfUrl}
                    alt=""
                    className="image-preview"
                    onLoad={() => setLoading(false)}
                />
            ) : (
                <Document
                    file={pdfUrl}
                    onLoadSuccess={onDocumentLoadSuccess}
                    onLoadError={onLoadError}
                    renderMode="canvas"
                >
                    {Array.from(new Array(numPages), (_, index) => (
                        <Page
                            key={`page_${index + 1}`}
                            pageNumber={index + 1}
                            width={width || defaultWidth} // Ensure it fits the container
                            scale={scale} // Scale without excessive zoom
                        />
                    ))}
                </Document>
            )}
        </div>
    );
};

export default PdfPreview;
